<template>
  <div class="trade-success">
    <img class="trade-success-img" src="@assets/images/trade_success.png" alt="">
	<p class="check-pass">验证通过</p>
	<div class="info">{{info}}</div>
	<div class="zhuanfa">
		<p>{{info2}}</p>
	</div>
  </div>
</template>

<script>

import { oldnewSuccess } from "@api/activity";
import { openShareAll, wxShowLocation } from "@libs/wechat";
export default {
  name: "TradeSuccess",
  components: {
    
  },
  data() {
    return {
	  isWeixin: ithis.$wechat.isWeixin(),
	  info:"",
	  info2:""
    };
  },
  mounted() {
	this.getoldnewSuccess();
  },
  methods: {
	getoldnewSuccess(){
		let that = this;
		oldnewSuccess().then(res => {
			that.info = res.data.info;
			that.info2 = res.data.info2;
			if (this.$wechat.isWeixin()) {
				var data = res.data.share;
				var configAppMessage = {
				  desc: data.desc,
				  title: data.title,
				  link: data.url,
				  imgUrl: data.image,
				  success: function(res){
				  	console.log('成功')
				  },
				  fail: function(res){
					console.log('失败')
					console.log(res)
				  }
				};
				openShareAll(configAppMessage);
			}
		}).catch(err => {
			that.$dialog.error(err.msg);
		})
	}
  },
  
};
</script>
<style scoped>
.trade-success{background-color: #fff;padding: 0 0.5rem;}
.trade-success-img{width: 1.62rem;display: block;margin: 0 auto;margin-top: 20%;}
.check-pass{width: 100%;text-align: center;font-size: 0.32rem;font-weight: bold;margin: 0.35rem 0 0 0;}
.info{line-height: 0.46rem;border-bottom: 1px solid #d9d9d9;padding: 0.6rem 0;}
.zhuanfa{margin: 0.6rem 0;background-color: #f5f5f5;border-radius: 5px;padding: 0.45rem;}
.zhuanfa p{color: #ef3841;}
</style>
